<template>
    <b-form class="mt-3" @submit.prevent="">
      <b-form-group label="Conveniado">
        <b-form-input
          @focus="showConveniadoFilter=true"
            name="filterConveniado"
            v-model="filterConveniadoText"
          ></b-form-input>
          <div class="filtered-select" v-if="showConveniadoFilter">
            <ul>
              <li v-for="conveniado of filteredConveniados" :key="conveniado._id" @click="selectConveniado(conveniado)">{{conveniado.nome}}</li>
            </ul>
          </div>
      </b-form-group>
      <b-form-group label="Procedimento" label-for="exampleInput1" v-if="pagamento.conveniado">
        <b-form-input
        @focus="showProcedimentoFilter=true"
          name="filterProcedimento"
          v-model="filterProcedimentoText"
        ></b-form-input>
        <div class="filtered-select" v-if="showProcedimentoFilter">
          <ul>
            <li v-for="(tabelaPreco, index) of filteredProcedimentos" :key="index" @click="selectProcedimento(tabelaPreco?tabelaPreco:{})">{{tabelaPreco?tabelaPreco.procedimento.descricao:""}}</li>
          </ul>
        </div>
      </b-form-group>
      <b-form-group label="Valor" label-for="exampleInput3">
        <b-form-input
          id="exampleInput3"
          v-model="pagamento.valor"
          v-money="money"
          class="edit-input"
          type="text"
          required
          disabled
          placeholder="00,00"
        />
      </b-form-group>
      <b-form-group label="Status" label-for="exampleInput4">
        <b-form-select
          v-model="pagamento.status"
          :options="statusOption"
          class="edit-input"
        >
        </b-form-select>
      </b-form-group>
      <b-form-group label="Forma De pagamento" label-for="exampleInput5">
        <b-form-select
          v-model="pagamento.forma_pagamento"
          :options="formPgtOption"
          class="edit-input"
        >
        </b-form-select>
      </b-form-group>
      <b-form-group label="Comprovante De pagamento" label-for="exampleInput6">
        <b-form-input
          id="exampleInput6"
          v-model="pagamento.comprovante"
          v-mask="'#########.##'"
          class="edit-input"
          type="text"
          required
          placeholder="123123456-21"
        />
      </b-form-group>
      <b-button type="submit" variant="primary" @click.prevent.stop="formValidate"
        >Salvar</b-button>
      <loading :active.sync="isLoading" color="#ed969e" :can-cancel="true"></loading>
    </b-form>
</template>
<script>
import conveniadoMixin from '@/src/mixins/conveniadoMixin'
import {VMoney} from 'v-money'
import Loading from 'vue-loading-overlay'

export default {
  components: {Loading},
  props: ['pagamento', 'onSubmit', 'onEdit'],
  mixins: [conveniadoMixin],
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true
      },
      conveniados:[],
      statusOption:[
        {value:'Aberto', text:'Aberto'},
        {value:'Fechado', text:'Fechado'},
      ],
      formPgtOption:[
        {value:'Dinheiro', text:'Dinheiro'},
        {value:'Pix', text:'Pix'},
      ],
      isLoading: false,
      showConveniadoFilter: false,
      showProcedimentoFilter: false,
      filterConveniadoText: '',
      filteredConveniados: [],
      conveniadoSelected: {},
      filterProcedimentoText: '',
    }
  },
  directives: {money: VMoney},
  mounted(){
    this.listando()
  },
  watch:{
    filterConveniadoText(){
      this.filterConveniado(this.filterConveniadoText)
      this.showConveniadoFilter = true
    },
  },
  methods: {
    selectProcedimento(tabelaPreco){
      this.pagamento.procedimento = tabelaPreco?tabelaPreco.procedimento:{}
      this.pagamento.valor = tabelaPreco.custoProcedimento
      this.filterProcedimentoText = tabelaPreco?tabelaPreco.procedimento.descricao:""
      setTimeout(() => {
        this.showProcedimentoFilter = false
      }, 100);
    },
    filterProcedimentos(procedimentos){
      let verifiedProcediemntos = []
      if(procedimentos.length){
        for (let i = 0; i < procedimentos.length; i++) {
          if(procedimentos[i])
            if(procedimentos[i]["custoProcedimento"]!==0){
              verifiedProcediemntos.push(procedimentos[i])
            }
          
          if(i>=procedimentos.length-1){
            return verifiedProcediemntos
          }
        }
      }
    },
    filterProcedimento(filter){
      if(!filter){
        this.filteredProcedimentos = this.filterProcedimentos(this.conveniadoSelected?this.conveniadoSelected.tabelaPreco:[]).slice(0,4)
        return
      }
      
      let procedimentos = this.conveniadoSelected?this.conveniadoSelected.tabelaPreco:[].filter(i=>(i?(i.procedimento.descricao.toLowerCase()).includes(filter.toLowerCase()):false)).slice(0,4)
      this.filteredProcedimentos = this.filterProcedimentos(procedimentos).slice(0,4)
    },
    selectConveniado(conveniado){
      this.conveniadoSelected = conveniado
      this.filterProcedimento()
      this.pagamento.conveniado = conveniado._id
      this.filterConveniadoText = conveniado.nome
      setTimeout(() => {
        this.showConveniadoFilter = false
        this.showFormConveniadoFilter = false
      }, 100);
    },
    filterConveniado(filter){
      if(!filter){
        this.filteredConveniados = this.conveniados.slice(0,4)
        console.log(this.filteredConveniados)
        return
      }
      
      this.filteredConveniados = this.conveniados.filter(i=>(i.nome.toLowerCase()).includes(filter.toLowerCase())||
      (i.registro?i.registro.toLowerCase():"").includes(filter.toLowerCase())).slice(0,4)
    },
    listando(){
      this.isLoading = true
      this.conveniados = []
      this.loadConveniados()
        .then((conveniados) => {
          this.conveniados = conveniados
          this.filterConveniado()
          this.isLoading = false
        }

        ).catch(() => {
            this.isLoading = false
            this.errorMessage('Ops... Não conseguimos atender sua solicitação :(')
          }
        )
    },
    formValidate(){
      if(this.pagamento._id){
        this.onEdit()
      }else{
          this.onSubmit()
        }
    }
  },
}
</script>
<style scoped>
.filtered-select{
  background-color: white;
  width: 90%;
  right: 0;
  z-index: 40;
}
.filtered-select ul{
  list-style: none;
  padding-left: 19px;
}
.filtered-select ul li{
  padding-top: 10px;
  padding-left: 10px;
  font-size: 14px;
  border-radius: 2%;
  justify-content: center;
}
.filtered-select ul li:hover{
  background-color: #0088a8;
  color: white;
  transition: 200ms;
}
</style>
